module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.jpg.pvr.5f23210d.ktx";